<template>
    <div class="total">
        <el-row>
          <el-col :span="6"><h2>{{title}}</h2></el-col>
        </el-row>
        <el-row>
            <el-col :span="5">
                <div style="margin-top: 15px;">
                    <el-date-picker
                      v-model="year"
                      type="year"
                      placeholder="选择年">
                    </el-date-picker>
                </div>
            </el-col>
            <el-col :span="10">
                <div style="margin-top: 15px;">
                  <el-input placeholder="请输入型号（必填）" v-model="input" class="input-with-select">
                    <el-select v-model="select" slot="prepend" placeholder="请选择">
                      <el-option label="A线" value="A线"></el-option>
                      <el-option label="B线" value="B线"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="getTotal"></el-button>
                  </el-input>
                </div>
            </el-col>
            <el-col :span="6" :offset="2">
                <div style="margin-top: 15px;">
                    <el-button type="primary" icon="el-icon-download"  @click="loadPlanInfo">导出报表</el-button>
                </div>
            </el-col>
        </el-row>
        <br>
        <el-table
            :data="tableData"
            border
            style="width: 100%"
            height="700"
            >
            <el-table-column
              prop="line"
              label="产线[A/B]线">
            </el-table-column>
            <el-table-column
              prop="date"
              label="时间">
            </el-table-column>
            <el-table-column
              prop="model"
              label="型号">
            </el-table-column>
            <el-table-column
              prop="output"
              label="产量">
            </el-table-column>
            <el-table-column
              prop="capacity"
              label="产能">
            </el-table-column>
            <el-table-column
              prop="alarmtimes"
              label="生产异常次数">
            </el-table-column>
            <el-table-column
              prop="alarmduring"
              label="异常持续时间(分钟)">
            </el-table-column>
            <el-table-column
              prop="alarmcontent"
              label="异常内容">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {export2Excel} from "../../excel/util";

    export default {
        name: "YearStatistics",
        data() {
          return {
            year: '',
            input: '',
            select: 'A线',
            title: '年统计报表',
            columns: [
                {title: '序号', key: 'id'},
                {title: '产线[A/B]线', key: 'line'},
                {title: '时间', key: 'date'},
                {title: '型号', key: 'model'},
                {titel: '产量', key: 'output'},
                {title: '产能', key: 'capacity'},
                {title: '生产异常次数', key: 'alarmtimes'},
                {title: '异常持续时间', key: 'alarmduring'},
                {title: '异常内容', key: 'alarmcontent'}
            ],
            tableData: [],
          }
        },
        methods: {
            // ---------------------------request------------start

            // 年排产
            getYearTotal(){
                let year = new Date(this.year).getFullYear();
                let data = {
                    year: year,
                    model: this.input,
                    line: this.select,
                };
                let line = this.select;
                this.axios.get("yreport", {params: data}).then((res) => {
                    this.select = line;
                    if(res.data.meta.status === 200){
                        if(res.data.data.length <= 0) return this.$message.info("没有数据！！！");
                        return this.tableData = [res.data.data];
                    }
                    return this.$message.warning("获取数据失败！！！");
                }).catch((err) => {
                    this.select = line;
                    return this.$message.error("请求异常！！！");
                })
            },


            // ---------------------------request------------end
            // 获取参数
            getTotal(){
                if(!this.input) return this.$message.warning("型号不能为空！！！");
                this.getYearTotal(); // 年排产
            },
            // 导出数据报表
            loadPlanInfo(){
                if(this.tableData.length > 0)
                return export2Excel(this.columns, this.tableData, this.title);
                return this.$message.info("无数据");
            },
        },
    }
</script>

<style scoped>

</style>